import reduce from 'lodash/reduce';
import i18next from '../shared/translations/i18n';
import {
    getDataByLanguage,
    loadCustomLabelTranslations,
} from '../shared/translations/i18nUtils';
import {
    getApiUri,
    getNonApiUri,
    getNodeServerUri,
} from '../viewDashboards/utils/getUri';
import { areGroupBysDifferent } from '../viewDashboards/widgets/utils/wrapperUtils';

export function buildSearchUriConstants() {
    const getUri =
        process.env.REACT_APP_NODE_SERVER === 'true'
            ? getNodeServerUri
            : getApiUri;

    return {
        // downloadDashboard: getNodeServerUri('DashboardApi/Download'),
        // pdfExportUri: getApiUri(`DashboardApi/PdfExport`),
        // auditLogUri: getUri('AuditLogApi'),
        getSharedUrl: (id) => getUri(`SharedUrl/GetSharedUrlById?id=${id}`),
        saveSharedUrl: getUri('SharedUrl/SaveSharedUrl'),
        getShareableUri: (externalLink) =>
            `${window.location.origin}${getNonApiUri(externalLink)}`,

        logMessageUri: getUri('Logging/LogMessage'),
        pageHelpUri: (onlineHelpId) =>
            `http://test-help/Default.htm#cshid=${onlineHelpId}`,

        getNonApiUri,
        getSystemManifestUri: getUri('DashboardApi/GetSystemManifest'),
        getSearchConfigurationUri: (searchKey) =>
            getUri(
                `SearchConfiguration/GetSearchConfiguration?searchKey=${searchKey}`
            ),
        getAllUserPreferences: getUri(`UserPreferences/GetAllUserPreferences`),
        getUserPreferences: (dashboardKey) =>
            getApiUri(
                `UserPreferences/GetUserPreferencesByKey?key=${dashboardKey}`
            ),
        saveUserPreferences: getApiUri('UserPreferences/SaveUserPreferences'),
        metricDataUri: getUri('DashboardMetric/GetMetricData'),
        selectOptionsUri: getUri('SelectOptions/GetCriteriaValues'),
    };
}

const TRANSLATION_KEY_REGEX = 'key:[^\\"]+';

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(`"${find}"`, 'g'), `"${replace}"`);
}

export function warnMissedTranslations(
    stringConfig,
    currentLanguage = i18next.language
) {
    const missedTranslations = stringConfig.match(
        new RegExp(TRANSLATION_KEY_REGEX, 'g')
    );

    if (missedTranslations) {
        // eslint-disable-next-line no-console
        console.error(
            `Translations missing for language <${currentLanguage}>: ${missedTranslations}`
        );
    }

    return missedTranslations;
}

export function replaceAllCustomLabels(config, customLabels) {
    const stringifiedConfig = JSON.stringify(config);

    const modifiedConfig = reduce(
        customLabels,
        (result, value, key) => replaceAll(result, key, value),
        stringifiedConfig
    );

    warnMissedTranslations(modifiedConfig);

    return JSON.parse(modifiedConfig);
}

export function initializeSearchConfiguration(config) {
    const { translations, ...configuration } = config;

    if (!translations) {
        // eslint-disable-next-line no-console
        console.warn(
            `Configuration doesn't have 'translations' property. This is unlikely to be correct.`
        );
        return config;
    }

    loadCustomLabelTranslations(translations);
    const { customLabels } = getDataByLanguage(i18next.language);

    return {
        translations,
        ...replaceAllCustomLabels(configuration, customLabels),
    };
}

export function validateSearchConfiguration(config) {
    const requiredConfigPropertyKeys = [
        'searchTitle',
        'siteMapKey',
        'showRecordLimit',
        'isShareEnabled',
        'isDownloadEnabled',
        'isEmailEnabled',
        'tableConfiguration',
        'metricRequests',
        'timeAndPrecisionConfiguration',
        'timeAndPrecision',
        'filterConfigurations',
        'filterValues',
        'whereClauseConfiguration',
        'whereClauses',
        'recordLimit',
        'isDescending',
    ];

    const missingConfigProperties = requiredConfigPropertyKeys.filter(
        (key) => !Object.hasOwn(config, key)
    );

    if (missingConfigProperties.length) {
        throw new Error(
            `Configuration is missing required properties: ${missingConfigProperties.join(
                ', '
            )}`
        );
    }

    if (areGroupBysDifferent(config.metricRequests)) {
        throw new Error(
            `All metric requests must have the same group bys specified.`
        );
    }
}
